import { connect } from 'react-redux'
import { getFromSettings } from 'src/utils/helpers'

import AclRoute from './AclRoute'

const mapStateToProps = (state) => {
  return {
    features: getFromSettings(state, 'features', {}),
  }
}

export default connect(mapStateToProps, null)(AclRoute)
